import React, { useMemo } from "react";
import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

// based on "PORSHE" (https://sketchfab.com/3d-models/porshe-f18f0887860b4fc1939470e134a33281)
// by Batman KNIGHTs (https://sketchfab.com/BATMAN13k) licensed under CC BY 4.0 (http://creativecommons.org/licenses/by/4.0/)
export function Car() {
    const gltf = useLoader(
        GLTFLoader,
        process.env.PUBLIC_URL + "/models/mercedes/Mercedes-Benz E53 Cabrio AMG 2021_v2.glb"
    );

    const scene = useMemo(() => {
        const s = gltf.scene;

        s.scale.set(0.024, 0.024, 0.024);
        s.position.set(0, -.1, 0);
        return s;

    }, [gltf]);


    return <primitive object={scene} />;
}